import React from "react";
import './src/styles/global.css';
import './src/styles/lookbook.css';
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/scrollbar"
import "swiper/css/virtual"
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css'
import "react-toastify/dist/ReactToastify.css"

import { QuickBuyProvider } from './src/context/QuickBuyContext.jsx'
import { BBxBratzProvider } from './src/context/BBxBratzContext.jsx'
import { StoreProvider } from './src/context/StoreContext.jsx'

import { UserProvider } from './src/context/UserContext.jsx'
import { ToastContainer } from "react-toastify"

import { ApolloProvider } from '@apollo/client';
import client from './src/context/apollo';

import { I18nextProvider } from 'react-i18next';
import i18n from './src/i18n/config';
import { LocaleProvider } from './src/context/LocaleContext.jsx';
import LangUrlSync from './src/components/LangUrlSync.jsx';

export const wrapRootElement = ({ element }) => (
    <React.StrictMode>
        <I18nextProvider i18n={i18n}>
            <ApolloProvider client={client}>
                <QuickBuyProvider>
                    <UserProvider>
                        <BBxBratzProvider>
                            <StoreProvider>
                                <LocaleProvider>{element}</LocaleProvider>
                            </StoreProvider>
                        </BBxBratzProvider>
                    </UserProvider>
                </QuickBuyProvider>
                <ToastContainer
                    position='top-right'
                    autoClose={3000}
                    hideProgressBar
                    closeButton={false}
                    toastClassName={() => 'p-0'}
                />
            </ApolloProvider>
        </I18nextProvider>
    </React.StrictMode>
)

export const wrapPageElement = ({ element, props }) => (
    <>
        <LangUrlSync location={props.location} />
        {element}
    </>
)

export const onInitialClientRender = () => {
    document.addEventListener("geCartAttributes", () => {}, false)
}

export const shouldUpdateScroll = ({
    routerProps: { location },
    getSavedScrollPosition,
}) => {
    const savedPosition = getSavedScrollPosition(location) || [0, 0]
    window.setTimeout(() => window.scrollTo(...savedPosition), 0)
    return false
}